export default "__VITE_ASSET__BiTrXc6V__"